module.exports = __webpack_public_path__ + "static/media/section1-clients.ab1aa0ea.svg";